import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { catchError, Observable, of } from 'rxjs';
import { cancelOrderInput, ErrorResponse, PlaceOrderInput, requestOrder, requestReturn } from '../../inputs/order.input';
import { OrdersResponse, OneOrderResponse, OrderInfo, OrderResponse, OrderListResponse } from '../../models/product/order.model';
import { ReturnProduct, ReturnProductList, SubmitResponse } from '../../models';

@Injectable({
  providedIn: 'root'
})
export class OrderService extends HttpService<PlaceOrderInput | cancelOrderInput | string | requestOrder | requestReturn, OrdersResponse | OneOrderResponse> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'orders');
  }

  getOrdersByCustomerId(): Observable<OrderListResponse> {
    return this.getAll('user').pipe(catchError((error) => of(error)));
  }
  getOrdersFilterByUser(parameter: requestOrder): Observable<OrderListResponse> {
    return this.create(parameter, 'filter-user').pipe(catchError((error) => of(error)));
    // return this.getAll('filter-user').pipe(catchError((error) => of(error)));
  }


  placeOrder(order: PlaceOrderInput): Observable<SubmitResponse> {
    return this.create(order).pipe(catchError((error) => of(error)));
  }
  cancelOrder(cancelOrder: cancelOrderInput): Observable<any> {
    return this.createHttpRes(cancelOrder, 'cancel').pipe(
      catchError((error: any) => {
        return of({ success: false, message: 'Failed to cancel order' } as ErrorResponse);
      })
    );
  }

  // order confirm 
  getOrderByOrderId(orderId: number): Observable<OrderResponse> {
    return this.getById(orderId).pipe(catchError((error) => of(error)));
  }
   getOrderByOrderIdNetwork(orderId: number): Observable<OrderResponse> {
    return this.getById(orderId+'/payment').pipe(catchError((error) => of(error)));
  }
  // order confirm 
  placeOrderAgain(orderId: string): Observable<SubmitResponse> {
    return this.create('', orderId + '/order-again').pipe(catchError((error) => of(error)));
  }
  // return
  getReturnOrdersCustomer(filter: requestOrder): Observable<ReturnProductList> {
    return this.create(filter, 'return/list').pipe(catchError((error) => of(error)));

  }
    getReturnOrdersFilter(filter: requestOrder): Observable<ReturnProductList> {
    return this.create(filter, 'return/filter').pipe(catchError((error) => of(error)));

  }
  getShippingFeeByOrderId(orderId: string): Observable<SubmitResponse> {
    return this.getById('return/fee/' + orderId).pipe(catchError((error) => of(error)));
  }
  returnRequest(request: requestReturn): Observable<SubmitResponse> {
    return this.create(request,'return/request').pipe(catchError((error) => of(error)));
  }
 getReturnItem(returnId: string): Observable<SubmitResponse> {
    return this.getById('return/item/' + returnId).pipe(catchError((error) => of(error)));
  }
   getInvoiceOrderId(orderId: string): Observable<OrderResponse> {
    return this.getById('invoice/'+orderId).pipe(catchError((error) => of(error)));
  }
  getCancelOrderTabby(orderId: string): Observable<SubmitResponse> {
    return this.getById(orderId+'/cancel-tabby-checkout-session').pipe(catchError((error) => of(error)));
  }
  getCancelOrderTamara(orderId: string): Observable<SubmitResponse> {
    return this.getById(orderId+'/cancel-tamara-checkout-session').pipe(catchError((error) => of(error)));
  }
}
